import Layout from '../../../components/common/pageLayout'
import Component from '../../../components/SiteManagement/pending/CustomerPropertyInventory'

const BlockInspectionStatusMasterlist = () => {
    return (
        <Layout
            title={'Customer Property Inventory'}
        >
            <Component 
            />
        </Layout>
    )
}

export default BlockInspectionStatusMasterlist